module.exports = function anonymous(it
) {
var out='<span> '+(it.title)+' ';if(it.substitute){out+=' <span class="substitute-name">'+(it.substitute.name)+' ('+(it.substitute.username)+')</span> ';}out+='</span>';return out;
}